import React from 'react';
import User from 'app/scripts/models/user';
import { UserControlsProps } from './AddReporter';

interface Props extends UserControlsProps {
  removeReporter: (user: User) => void;
}

const AddReporterControls: React.FC<Props> = ({
  user,
  removeReporter = (user: User) => {},
  onItemSelected = () => {}
}) => {
  const onClick = () => {
    removeReporter(user);
    onItemSelected();
  };

  return (
    <div className="teammates-controls">
      <span onClick={onClick} className="remove-link">
        Remove
      </span>
    </div>
  );
};

export default AddReporterControls;
